import * as React from "react";
import { LibraryCard } from "../../../types/LibraryCard";
import BookCard from "../BookCard/BookCard";
import "./BookCardWrapper.css";

interface Props {
	libraryCard: LibraryCard;
}

const BookCardWrapper: React.FunctionComponent<Props> = ({ libraryCard }) => {
	if (!libraryCard) {
		return <BookCard />;
	}

	return (
		<>
			<BookCard card={libraryCard} />

			<a className="bookCard-peekCategory-wrapper bookCard-goToCard" href={`/book/${libraryCard.book.woo_id}`}>
				Перейти к карточке
			</a>
		</>
	);
};

export default BookCardWrapper;
